/* eslint-disable react/require-default-props */

import React from 'react';
import {
  Box,
  Button,
  FooterActionBar,
  Icon,
  Tooltip,
} from '@saviynt/design-system';
import cx from 'classnames';
import { useSelector } from 'react-redux';

import { type RootState } from '../../../services/types';
import { useInvertedLocalize } from '../../../utils/localization';

import invertedMessages from './messages';

import './Footer.css';

interface FooterProps {
  onBack?: () => void; // for back button click
  onActivateRole?: () => void;
  isActivating?: boolean;
  isActivateButtonDisabled?: boolean;
  className?: string;
}

/**
 * Footer component containing Back and Save & Activate Role buttons
 *
 * @param props - The component props
 * @returns JSX element containing the footer
 */
function Footer({
  onBack,
  onActivateRole,
  isActivating = false,
  isActivateButtonDisabled = false,
  className,
}: FooterProps) {
  const l = useInvertedLocalize(invertedMessages);

  // Get menu pinned state from Redux store
  const isMenuPinned = useSelector(
    (state: RootState) => state.user.isMenuPinned
  );

  return (
    <FooterActionBar
      className={cx(
        'Roles-Footer',
        className,
        isMenuPinned && 'Roles-Footer--isMenuPinned'
      )}
      size='large'>
      <Box className='Roles-Footer-backButtonContainer'>
        <Button
          kind='outlined'
          onClick={onBack}
          className='Roles-Footer-backButtonContainer-backButton'>
          {l('Back')}
        </Button>
      </Box>

      <Box className='Roles-Footer-activateButtonContainer'>
        <Tooltip
          text={
            isActivateButtonDisabled
              ? l(
                  "You don't have the permissions to activate or the feature is turned off."
                )
              : ''
          }
          isDisabled={!isActivateButtonDisabled}
          placement='top'>
          <Button
            kind='filled'
            onClick={onActivateRole}
            isLoading={isActivating}
            isDisabled={isActivateButtonDisabled}
            loaderText={l('Activating...')}
            leftIcon={
              <Icon
                kind='QuickAction'
                size='medium'
                color='--color-foreground-neutral-inverse'
              />
            }
            className='Roles-Footer-activateButtonContainer-activateButton'>
            {l('Save & Activate Role')}
          </Button>
        </Tooltip>
      </Box>
    </FooterActionBar>
  );
}

export default Footer;
